import { Model_VariableEnvironnementUser, AbsPaginatedGrid } from 'src/app/app.models';
import { QueryParams_VariableEnvironnement } from 'src/app/pages/views/settings/variable-environment/variable-environment.service';

export abstract class EnvVarUserOfflineDao {
    abstract doSyncEnvironmentVariablesUserAction(_envVars: Model_VariableEnvironnementUser[]): Promise<void>;
    abstract doClearEnvironmentVariablesUserAction(): Promise<void>;
    abstract doGetEnvironmentVariablesUserAction(_queryParams?: any): Promise<Model_VariableEnvironnementUser[]>;
    abstract doInsertEnvironmentVariablesUserAction(_envVars: Model_VariableEnvironnementUser[]): Promise<void>;
    abstract doSaveEnvironmentVariablesUserAction(_envVar: Model_VariableEnvironnementUser): Promise<Model_VariableEnvironnementUser>;
    abstract doGetEnvironmentVariableUserAction(_nomVariable: string): Promise<Model_VariableEnvironnementUser>;
}